module.exports = __webpack_public_path__ + "media/images/modal/Pop-Up_Rocketcoins_01-70139b9e8d04250790d8cb8577dead5b.png";